<template>
    <div class="content lic-detail-page">
        <div class="container">
            <!-- 돌아가기 버튼 -->
            <button class="btn-back" @click="goBack">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                돌아가기
            </button>

            <!-- 페이지 타이틀 -->
            <div class="page-title">
                <h2 class="tit">계약 상세</h2>
            </div>

            <!-- 본문 -->
            <div v-if="state.loading" class="panel">
                <div class="empty">불러오는 중…</div>
            </div>

            <div v-else-if="!state.license" class="panel">
                <div class="empty">데이터를 찾을 수 없습니다.</div>
            </div>

            <div v-else class="panel">
                <!-- 라이선스 정보 -->
                <div class="panel-header">
                    <div class="left">
                        <strong>라이선스 정보</strong>
                    </div>
                </div>

                <div class="member-info">
                    <div class="info-row">
                        <label>제품명</label>
                        <div class="info-value">{{ state.license.productName }}</div>
                    </div>
                    <div class="info-row">
                        <label>시리얼 번호</label>
                        <div class="info-value">{{ state.license.serialNumber }}</div>
                    </div>
                    <div class="info-row">
                        <label>수량</label>
                        <div class="info-value">{{ state.license.quantity }}</div>
                    </div>
                    <div class="info-row">
                        <label>시작일</label>
                        <div class="info-value">{{ state.license.startDate ? formatDate(state.license.startDate) : '-' }}</div>
                    </div>
                    <div class="info-row">
                        <label>만료일</label>
                        <div class="info-value">{{ state.license.endDate ? formatDate(state.license.endDate) : '-' }}</div>
                    </div>
                </div>

                <!-- 클라이언트 정보 -->
                <div v-if="state.clientInfo" class="divider"></div>

                <div v-if="state.clientInfo" class="panel-header">
                    <div class="left">
                        <strong>고객 정보</strong>
                    </div>
                </div>

                <div v-if="state.clientInfo" class="member-info">
                    <div class="info-row">
                        <label>회사/개인</label>
                        <div class="info-value">{{ state.clientInfo.company ? '회사' : '개인' }}</div>
                    </div>
                    <div class="info-row">
                        <label>회사명</label>
                        <div class="info-value">{{ state.clientInfo.companyName || '-' }}</div>
                    </div>
                    <div class="info-row">
                        <label>사업자등록번호</label>
                        <div class="info-value">{{ state.clientInfo.bizNo || '-' }}</div>
                    </div>
                    <div class="info-row">
                        <label>담당자</label>
                        <div class="info-value">{{ state.clientInfo.clientManager || '-' }}</div>
                    </div>
                    <div class="info-row">
                        <label>담당자 이메일</label>
                        <div class="info-value">{{ state.clientInfo.managerEmail || '-' }}</div>
                    </div>
                    <div class="info-row">
                        <label>주소</label>
                        <div class="info-value">
                            <span v-if="state.clientInfo.clientAddress1">{{ state.clientInfo.clientAddress1 }}</span>
                            <span v-if="state.clientInfo.clientAddress2"> {{ state.clientInfo.clientAddress2 }}</span>
                            <span v-if="!state.clientInfo.clientAddress1 && !state.clientInfo.clientAddress2">-</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContractDetail',
    props: {
        crewId: [String, Number],
        licenseId: [String, Number],
    },
    data() {
        return {
            state: {
                loading: false,
                license: null,
                clientInfo: null,
            },
        };
    },
    mounted() {
        // CSS 파일 동적 로드
        if (!document.querySelector('link[href="/ssflex/assets/css/crew-license-manager.css"]')) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = '/ssflex/assets/css/crew-license-manager.css';
            document.head.appendChild(link);
        }
        this.loadContractDetail();
    },
    methods: {
        goBack() {
            const crewId = this.crewId ?? this.$route.params.crewId;
            // 계약 탭으로 돌아가기
            this.$router.push({
                name: 'licenseManagement',
                query: {
                    crewId: crewId,
                    mainTab: 'contract',
                },
            });
        },
        loadContractDetail() {
            const crewId = this.crewId ?? this.$route.params.crewId;
            const licenseId = this.licenseId ?? this.$route.params.licenseId;

            if (!crewId || !licenseId) {
                this.gritterErr('잘못된 접근입니다.');
                this.$router.replace({ name: 'licenseManagement' });
                return;
            }

            this.state.loading = true;
            this.axiosCaller.get(
                this,
                this.APIs.LICENSE + '/getContractDetail',
                { crewId, licenseId },
                (result) => {
                    try {
                        const data = result?.data || {};
                        if (data.status === 'ok') {
                            this.state.license = data.license || null;
                            this.state.clientInfo = data.clientInfo || null;
                        } else {
                            this.gritterErr(data.msg || '계약 정보 조회 실패');
                        }
                    } finally {
                        this.state.loading = false;
                    }
                }
            );
        },
        formatDate(dateString) {
            if (!dateString) return '-';
            const date = new Date(dateString);
            return date.toLocaleDateString('ko-KR');
        },
        gritterErr(msg) {
            const m = msg || '정상적인 접근이 아닙니다. 다시 시도해주세요.';
            this.swalUtils?.gritter
                ? this.swalUtils.gritter('error', m, 'error', 2000)
                : console.error('[ERR]', m);
        },
    },
};
</script>

<style scoped>
/* 외부 CSS 파일 사용: /ssflex/assets/css/crew-license-manager.css */
</style>

